import React from 'react'
import { useT } from './translations'

const SaveStatus = ({ saving }) => {
  const t = useT()

  if (saving.error) {
    return <span className="fb-save is-error" title={saving.error}><i className="fas fa-exclamation-circle" /> {t.save_error}</span>
  }
  if (saving.pending > 0) {
    return <span className="fb-save is-saving"><i className="fas fa-circle-notch fa-spin" /> {t.saving}</span>
  }
  return <span className="fb-save"><i className="fas fa-check" /> {t.saved}</span>
}

const TopBar = ({ blueprint, saving, meta, hasPdf, view, setView, onSettings }) => {
  const t = useT()

  return (
    <header className="fb-topbar">
      <a href={meta.urls.back} className="fb-icon-button" title={t.back}>
        <i className="fas fa-arrow-left" />
      </a>

      <div className="fb-title">
        <button type="button" className="fb-title-name" onClick={onSettings} title={t.form_settings}>
          {blueprint.name}
        </button>
        <div className="fb-title-sub">
          {blueprint.pdf_template
            ? <><i className="far fa-file-pdf" /> {blueprint.pdf_template.filename}</>
            : (blueprint.display_name || t.no_background)}
        </div>
      </div>

      {hasPdf &&
        <div className="fb-segmented">
          <button type="button" className={view === 'pdf' ? 'active' : ''} onClick={() => setView('pdf')}>
            <i className="far fa-file-pdf" /> {t.view_pdf}
          </button>
          <button type="button" className={view === 'form' ? 'active' : ''} onClick={() => setView('form')}>
            <i className="fas fa-mobile-alt" /> {t.view_form}
          </button>
        </div>
      }

      <div className="fb-topbar-actions">
        <SaveStatus saving={saving} />
        <button type="button" className="fb-button" onClick={onSettings}>
          <i className="fas fa-cog" /> {t.form_settings}
        </button>
        <a href={meta.urls.preview} target="_blank" rel="noopener noreferrer" className="fb-button">
          <i className="far fa-eye" /> {t.test_form}
        </a>
        <a href={meta.urls.back} className="fb-button is-primary">{t.done}</a>
      </div>
    </header>
  )
}

export default TopBar
